<div class="fab-container">
  <button (click)="fabClick.emit($event)" [disabled]="disabled" [matTooltip]="label" class="fab-toggle" color="accent"
          mat-fab matTooltipHideDelay="200"
          matTooltipPosition="left" matTooltipTouchGestures="on">
    <mat-icon inline [fontSet]="fontSet" [fontIcon]="fontIcon"></mat-icon>
  </button>
</div>
